import { axiosRequest } from "helpers";

export const servicePageService = {
	sendService
};

const API_URL = process.env.REACT_APP_API_URL;

function sendService(model) {
	const options = {
		method: "POST",
		data: model,
		params: {
			token: model?.token,
		},
		url: `${API_URL}/api/pre_applications/${model?.applicationId}/service`,
	};
	return axiosRequest(options);
}
